var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_153",
    "data-name": "Group 153",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M1781.991,3282.889c-.094.055-.19.115-.287.178v1.594a5.97,5.97,0,0,0,1.267-2.177A2.71,2.71,0,0,0,1781.991,3282.889Z",
    transform: "translate(-1764.091 -3277.191)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1740.85,3329.55h0Z",
    transform: "translate(-1731.171 -3315.116)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 -1.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M1764.331,3286.549l.264.264a.494.494,0,1,1-.7.7l-.289-.289-.074.072a14.882,14.882,0,0,0-1.485,1.715l.786.786a14.925,14.925,0,0,0,1.715-1.485,15.626,15.626,0,0,0,1.164-1.292v-1.531A12.072,12.072,0,0,0,1764.331,3286.549Z",
    transform: "translate(-1748.776 -3279.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M1744.453,3316.057l-.232,1.078a1.105,1.105,0,0,1,.1.089,1.086,1.086,0,0,1,.089.1l1.08-.233a2.722,2.722,0,0,1,.817-1.8l-.046-.046A2.671,2.671,0,0,1,1744.453,3316.057Z",
    transform: "translate(-1734.273 -3303.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 0.365,
    height: 2.149,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 11.949, 9.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M1781.98,3278.555a2.6,2.6,0,0,1,.941-.39,5.731,5.731,0,0,1-1.216,2.091v1.51c1.483-1.595,2.746-3.528,1.938-4.335-.384-.384-1.035-.333-1.938.147v1.148C1781.8,3278.665,1781.89,3278.607,1781.98,3278.555Z",
    transform: "translate(-1764.766 -3273.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(0.609 1.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M1694.141,3347.539a2.32,2.32,0,0,0,2.24,1.727h8.319a4.289,4.289,0,0,1-.8-1.727Z",
    transform: "translate(-1694.141 -3331.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M1709.866,3261.564a2.042,2.042,0,0,0-2.036,2.047v12.316h7.947a.836.836,0,0,1,.835.814,2.665,2.665,0,0,0,2.65,2.582c.052,0,.1,0,.152,0a2.351,2.351,0,0,0,2.193-2.341v-7.912l-.016.017c-.148.159-.3.315-.449.465a16.1,16.1,0,0,1-1.758,1.529.828.828,0,0,1,.065.323h0a.827.827,0,0,1-.243.588l-.481.48a.831.831,0,0,1-1.176,0l-.148-.147h0a1.709,1.709,0,0,0-.527,1.36c0,.026.005.043.006.047a.493.493,0,0,1-.381.577l-1.859.4a.482.482,0,0,1-.1.011.493.493,0,0,1-.089-.013l-.795.2a.265.265,0,0,1-.07.009.28.28,0,0,1-.28-.284.271.271,0,0,1,.011-.073l.211-.732a.28.28,0,0,1,.034-.073.5.5,0,0,1,.01-.12l.4-1.858a.5.5,0,0,1,.576-.382,1.679,1.679,0,0,0,1.407-.521h0l-.148-.147a.826.826,0,0,1-.244-.588h0a.826.826,0,0,1,.244-.588l.48-.48a.833.833,0,0,1,.588-.237h0a.846.846,0,0,1,.32.062,15.927,15.927,0,0,1,1.531-1.761c.131-.132.264-.259.4-.384a.46.46,0,0,1,.029-.036.442.442,0,0,1,.075-.06,12.873,12.873,0,0,1,2.157-1.652c.076-.044.15-.085.222-.124v-.408c.256-1.481.671-2.641,2.156-2.862v-.043Zm2.3,10.9h-1.885a.466.466,0,0,1,0-.933h1.885a.466.466,0,0,1,0,.933Zm1.885-1.769h-3.77a.466.466,0,1,1,0-.932h3.77a.466.466,0,1,1,0,.932Zm1.054-1.821h-4.824a.466.466,0,1,1,0-.932h4.824a.466.466,0,1,1,0,.932Zm1.569-1.769h-6.392a.466.466,0,0,1,0-.933h6.392a.466.466,0,0,1,0,.933Zm1.874-1.769h-8.266a.466.466,0,0,1,0-.933h8.266a.466.466,0,0,1,0,.933Z",
    transform: "translate(-1705.277 -3261.564)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteApproval);
export default __webpack_public_path__ + "static/media/white_approval.890304f50c0117b239b97f7b18860518.svg";
export { ForwardRef as ReactComponent };